import DOMPurify from 'dompurify';

const update = (el, binding) => {
  const { value } = binding;
  // Customize your own options, refer to documentation
  const options = {
    RETURN_DOM: false,
    ALLOWED_TAGS: [
      // Headers
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      // Styles
      'b',
      'i',
      'em',
      'strong',
      's',
      'sup',
      'sub',
      // Paragraph / Line-breaks
      'p',
      'br',
      'hr',
      // Anchor
      'a',
      // Image
      'img',
      // List
      'ol',
      'ul',
      'li',
      // Blockquote
      'blockquote',
      // Table
      'table',
      'tbody',
      'caption',
      'tr',
      'th',
      'td',
      // Misc
      'div',
      'span'
    ]
  };

  el.innerHTML = DOMPurify.sanitize(value, options);
};

export default {
  // Vue Hook Functions
  // created: update, this will cause hydration mismatch
  mounted: update,
  updated: update,
  getSSRProps(binding) {
    return {
      id: binding.value,
      innerHTML: binding.value
    };
  }
};
